<div *ngIf = "(isCreateFolder || isCreateSubFolder ) && !isUpdateFolder">
    <div *ngIf = "!isFolderCreated && isCreateFolder && !isCreateSubFolder" class="Tabletitle">Create Folder</div>
    <div *ngIf = "!isFolderCreated && isCreateSubFolder && !isCreateFolder" class="Tabletitle">{{fetchedFolderName}}</div>
    <div *ngIf = "!isFolderCreated && isCreateSubFolder && !isCreateFolder" class="Tabletitle">Create Sub Folder</div>
    <div *ngIf = "!isFolderCreated" class="card-body">
        <form [formGroup]="createFormData">
            <div class="input-group-sm mb-3 input-group col-12">
                <div class="input-group-prepend">
                    <span class="input-group-text form-label-105">Name</span>
    
                </div>
                <input type="text" class="form-control" id="retention-name" formControlName="folder_name" name="retention-name" >
            </div>
    
            <div class="input-group-sm mb-3 input-group col-12">
                <div class="input-group-prepend">
                    <span class="input-group-text form-label-105">Categories</span>
                </div>
                <mat-select  formControlName="category_id"   multiple class="form-control" (selectionChange)="getDisplayListData(createFormData.value['category_id'])">
                    <mat-option>
                        <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'" [noEntriesFoundLabel]="'Not found'" name="search" [ngModelOptions]="{standalone: true}">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let category of allCategories|stringFilter:searchCtrl:'name'" [value]="category.id">
                        {{category.name}}</mat-option>
                </mat-select>
            </div>
    
            <div class="input-group-sm mb-3 input-group col-12" title="Example: 'meta_data->'properties'->>'City' = 'Chicago''">
                <div class="input-group-prepend">
                    <span class="input-group-text form-label-105">Criteria</span>
                </div>
                <input formControlName="search" [(ngModel)] = "query" class="form-control" id="retention-criteria" name="retention-criteria" readonly required>
            </div>
            <div class="col-lg-12 control-section">
                <ejs-querybuilder #querybuilder width="70%" [dataSource]="allCategoryProperties" [showButtons]="showButtons" [rule]="importRules" [columns]="filter" (change) = "getValue()" (dataBound)='dataBound()' (created)="createdControl()">
                </ejs-querybuilder>
                <button class="mb-3" style="float: right;" mat-stroked-button (click)=queryBuilder()>Generate
                    Criteria</button>
            </div>
    
            <div class="input-group-sm mb-3 input-group col-12">
                <div class="input-group-prepend">
                    <span class="input-group-text form-label-105">Display List</span>
                </div>
                <mat-select multiple formControlName="display_list" class="form-control">
                    <mat-option *ngFor="let displayData of properties" [value]="displayData">
                        {{displayData}}</mat-option>
                </mat-select>
            </div>
    
            <div class="input-group-sm mb-3 input-group col-12">
                <div class="input-group-prepend">
                    <span class="input-group-text form-label-105">Groups</span>
                </div>
                <mat-select formControlName="groups"  multiple class="form-control">
                    <mat-option>
                        <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'" [noEntriesFoundLabel]="'Not found'" name="search" [ngModelOptions]="{standalone: true}">
                        </ngx-mat-select-search>
                    </mat-option>
                    <div *ngFor="let group of fetchedGroups |stringFilter:searchCtrl:'name'">
                        <mat-option  [value]="group">
                            {{group}}
                        </mat-option>
                    </div>
                </mat-select>
            </div>
    
            <div class="input-group-sm mb-3 input-group col-12">
                <div class="input-group-prepend">
                    <span class="input-group-text form-label-105">Personal</span>
                </div>
                <mat-slide-toggle class="pl-2 pr-2 pt-1" (click)="togglePersonal()" formControlName="personal">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </mat-slide-toggle>
            </div>
            <div class="input-group-sm mb-3 input-group col-12" *ngIf = "showOwner">
                <div class="input-group-prepend">
                    <span class="input-group-text form-label-105">Owner</span>
                </div>
                <mat-select formControlName="owner" class="form-control" required>
                    <mat-option>
                        <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'" [noEntriesFoundLabel]="'Not found'" name="search" [ngModelOptions]="{standalone: true}">
                        </ngx-mat-select-search>
                    </mat-option>
                        <mat-option [value]="group" *ngFor="let group of fetchedGroups |stringFilter:searchCtrl:'name'">
                            {{group}}
                        </mat-option>
                </mat-select>
            </div>
    
            <button mat-raised-button class="closeButton m-2" style="float: right"  (click)=back(false) >Cancel</button>
            <button mat-raised-button class="actionButton m-2" style="float: right" [disabled]="!createFormData.valid" (click)="saveCreateData(createFormData.value)" mat-button>Create</button>
    
        </form>
    </div>
    
    
    <div class="card mt-5" *ngIf="isFolderCreated">
        <div class="card-body" style="text-align: center;">
            <div>Folder <strong>{{createFormData.value['folder_name']}} </strong>has been created.</div>
            <button class="closeButton" style="margin: 1em;float: right;" (click)=back(true) mat-raised-button>Back</button>
    
        </div>
    </div>
    
    </div>
    
    <div *ngIf = "!isCreateFolder && isUpdateFolder && !isCreateSubFolder">
        <div *ngIf = "!isFolderCreated" class="Tabletitle">Update Folder</div>
        <div *ngIf = "!isFolderCreated" class="card-body">
            <form [formGroup]="createFormData">
                <div class="input-group-sm mb-3 input-group col-12">
                    <div class="input-group-prepend">
                        <span class="input-group-text form-label-105">Name</span>
        
                    </div>
                    <input type="text" class="form-control" id="retention-name" formControlName="folder_name" name="folder-name" >
                </div>
        
                <div class="input-group-sm mb-3 input-group col-12">
                    <div class="input-group-prepend">
                        <span class="input-group-text form-label-105">Categories</span>
                    </div>
                    <mat-select  formControlName="category_id"   multiple class="form-control" (selectionChange)="getDisplayListData(createFormData.value['category_id'])">
                        <mat-option>
                            <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'" [noEntriesFoundLabel]="'Not found'" name="search" [ngModelOptions]="{standalone: true}">
                            </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let category of allCategories| stringFilter:searchCtrl:'name'" [value]="category.id">
                            {{category.name}}</mat-option>
                    </mat-select>
                </div>
        
                <div class="input-group-sm mb-3 input-group col-12" title="Example: 'meta_data->'properties'->>'City' = 'Chicago''">
                    <div class="input-group-prepend">
                        <span class="input-group-text form-label-105">Criteria</span>
                    </div>
                    <input formControlName="search" [(ngModel)] = "query" class="form-control" id="retention-criteria" name="retention-criteria" readonly required>
                </div>
                <div class="col-lg-12 control-section">
                    <ejs-querybuilder #querybuilder width="70%" [dataSource]="allCategoryProperties" [showButtons]="showButtons" [rule]="importRules" [columns]="filter"  (dataBound)='dataBound()' (created)="createdControl()">
                    </ejs-querybuilder>
                    <button class="mb-3" style="float: right;" mat-stroked-button (click)=queryBuilder()>Generate
                        Criteria</button>
                </div>
    
                <div class="input-group-sm mb-3 input-group col-12">
                    <div class="input-group-prepend">
                        <span class="input-group-text form-label-105">Display List</span>
                    </div>
                    <mat-select multiple formControlName="display_list" class="form-control">
                        <mat-option *ngFor="let displayData of properties" [value]="displayData">
                            {{displayData}}</mat-option>
                    </mat-select>
                </div>
        
                <div class="input-group-sm mb-3 input-group col-12">
                    <div class="input-group-prepend">
                        <span class="input-group-text form-label-105">Groups</span>
                    </div>
                    <mat-select  formControlName="groups"   multiple class="form-control">
                        <mat-option>
                            <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'" [noEntriesFoundLabel]="'Not found'" name="search" [ngModelOptions]="{standalone: true}">
                            </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let group of fetchedGroups | stringFilter:searchCtrl:'name'" [value]="group">
                            {{group}}</mat-option>
                    </mat-select>
                </div>
        
                <div class="input-group-sm mb-3 input-group col-12">
                    <div class="input-group-prepend">
                        <span class="input-group-text form-label-105">Personal</span>
                    </div>
                    <mat-slide-toggle class="pl-2 pr-2 pt-1" formControlName="personal">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </mat-slide-toggle>
                </div>
        
                <div *ngIf = "createFormData.value['personal'] == true">
                <div class="input-group-sm mb-3 input-group col-12">
                    <div class="input-group-prepend">
                        <span class="input-group-text form-label-105">Owner</span>
                    </div>
                    <mat-select  formControlName="owner" class="form-control" required>
                        <mat-option>
                            <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'" [noEntriesFoundLabel]="'Not found'" name="search" [ngModelOptions]="{standalone: true}">
                            </ngx-mat-select-search>
                        </mat-option>
                        <mat-option [value]="group" *ngFor="let group of fetchedGroups |stringFilter:searchCtrl:'name'">
                            {{group}}
                        </mat-option>
                    </mat-select>
                </div>
            </div>
        
                <button mat-raised-button class="closeButton m-2" style="float: right"  (click)=back(false) >Cancel</button>
                <button mat-raised-button class="actionButton m-2" style="float: right" [disabled]="!createFormData.valid" (click)="saveUpdateData(createFormData.value)" mat-button>Update</button>
        
        
        
            </form>
        </div>
        
        
        <div class="card mt-5" *ngIf="isFolderCreated">
            <div class="card-body" style="text-align: center;">
                <div><strong>Folder {{createFormData.value['folder_name']}} </strong>has been updated.</div>
                <button class="closeButton" style="margin: 1em;float: right;" (click)=back(true) mat-raised-button>Back</button>
        
            </div>
        </div>
    </div>
    